import { useCallback, useEffect } from 'react';
import _ from 'lodash';

// Debounced draft saves of the mounted editors, so the pending ones can be sent at once
const draftSaveDebounces = new Set();

// Sends every draft save still waiting in an editor's debounce, e.g. when the tab is
// hidden or closed, which otherwise lost the last second of typing.
export const flushPendingDraftSaves = () => {
  draftSaveDebounces.forEach((saveDraftDebounce) => saveDraftDebounce.flush());
};

// Hook to update draft and avoid rerendering when focus changes
export default function updateDraftHook(saveProposalDraft, setDisablePreview) {
  // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/rules-of-hooks
  const saveDraftDebouce = useCallback(
    _.debounce(
      (saveProposalDraftCurring, es, saveDraftSuccess) =>
        saveProposalDraftCurring(es, (response) => {
          saveDraftSuccess?.(response);
          setDisablePreview(false);
        }),
      1000
    ),
    []
  );

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    draftSaveDebounces.add(saveDraftDebouce);

    return () => {
      draftSaveDebounces.delete(saveDraftDebouce);
    };
  }, [saveDraftDebouce]);

  const saveDraft = (name, raw) => {
    const saveProposalDraftCurring = saveProposalDraft(name, raw);
    return (es, saveDraftSuccess = () => {}) => {
      setDisablePreview(true);
      saveDraftDebouce(saveProposalDraftCurring, es, saveDraftSuccess);
    };
  };

  return saveDraft;
}
